import type { ActionFunctionArgs, LoaderFunctionArgs } from "@remix-run/deno";
import { json, useLoaderData } from "@remix-run/react";
import * as React from "react";
import { RequestContext } from "../lib/request-context.ts";
import { redirect, render } from "../route-helpers.server.ts";

export const loader = async (env: LoaderFunctionArgs) => {
  const ctx = new RequestContext(env.request);

  return render(ctx, {
    ident: true,
  });
};

export const action = async (env: ActionFunctionArgs) => {
  return json({ reason: "Bad request" }, 400);
};

export default function Index() {
  const { bindings, fields } = useLoaderData();
  const user = bindings?.ident?.user;
  return (
    <div style={{ fontFamily: "system-ui, sans-serif", lineHeight: "1.4" }}>
      <h1>Welcome {user?.email || "Anonymous"}</h1>
    </div>
  );
}
